export const nativePlatformsInitialState = {
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    filterType: 'include',
    platform: 'nativePlatforms',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    isDisabled: true,
    hasActivateSwitch: true,
    hasIncludeExclude: true,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'nativePlatforms',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'nativePlatforms',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'nativePlatforms',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  languageFilter: {
    title: 'filter:baseOnLanguage',
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
    hasActivateSwitch: true,
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
        toggler: 'switch',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:resourceBasedOn',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
    isDisabled: true,
    hasActivateSwitch: true,
    openSubCategories: true,
  },
};
